var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5C9.5,40.2,40.2,9.5,78,9.5c37.8,0,68.5,30.7,68.5,68.5 C146.5,115.8,115.8,146.5,78,146.5z M78,14.3c-35.1,0-63.7,28.6-63.7,63.7s28.6,63.7,63.7,63.7s63.7-28.6,63.7-63.7 S113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,60.5c0.8-1.2,2.5-1.8,3.8-1.2c3.9,1.6,9,1.5,15.6-0.6c1.5-0.5,3,0.2,3.4,1.4c0.4,1.3-0.5,2.7-2,3.2 c-7.9,2.5-14.5,2.7-19.8,0.5C92.2,63.2,91.7,61.8,92.5,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1,60.9c0.9,0.9,0.7,2.1-0.5,2.6c-4.8,2-11.2,2.1-19.2,0.4c-1.5-0.3-2.6-1.4-2.4-2.4s1.6-1.6,3.1-1.3 c6.6,1.4,11.6,1.3,15.1-0.2C59.5,59.6,61.2,59.9,62.1,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,102c6.8,8.8,22.5,14.6,40,14.9c18.8,0.3,36.1-5.9,43-15.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress2);
export default __webpack_public_path__ + "static/media/Stress2.152d151e46fa96c18db48b33c2b9a66a.svg";
export { ForwardRef as ReactComponent };